export const generateUEID = () => {
  const generatedNumber1 = Math.random() * 46656;
  const generatedNumber2 = Math.random() * 46656;

  const first = `000${generatedNumber1.toString(36)}`.slice(-3);
  const second = `000${generatedNumber2.toString(36)}`.slice(-3);

  return first + second;
};
